<template>
  <div
    class="col-0 col-lg-3 col-xl-2 p-0 pl-2 pr-2 wp_displayNoneMobile"
    v-if="getFilter.length > 0"
  >
    <div class="filter-sidebar">
      <div class="wp_filterHeadingContainer">
        <div class="row">
          <div class="col-6">
            <h5 data-test="filterSidePanelHeading"
																id="filterSidePanelHeading">Filters</h5>
          </div>
          <div class="col-6">
            <div class="actions text-right">
              <a href @click.prevent="clearAllFilters" data-test="filterSidePanelClrLink"
																	id="filterSidePanelClrLink">Clear All</a>
            </div>
          </div>
        </div>
      </div>
      <div class="sidebar">
        <!--<button class="fiter-toggle-btn"-->
        <!--id="filter-btn"-->
        <!--&gt;-->
        <!--Close-->
        <!--</button>-->
        <price-slider-filter @priceUpdate="getFilteredProducts($event,'priceFilter')"/>

        <dl class="row m-0 wp_BorderBottom">
          <div class="col-12">
            <ul class="filter-selected-box list-unstyled">
              <!--<li class>-->
              <!--<span>Apple</span>-->
              <!--<span class="close-f">x</span>-->
              <!--</li>-->
              <li class v-for="(fil, index) in getSelectedFilterValues" :key="index">
                <span :data-test="'filterSidePanelFilterValue'+index"
																						:id="'filterSidePanelFilterValue'+index">{{fil}}</span>
                <!--<span class="close-f">x</span>-->
              </li>
            </ul>
          </div>
        </dl>

        <div class="sidebarsz">
          <filter-accordion
            v-for="(filter,index) in getFilter"
            :key="index"
            :filter="filter"
            v-show="filter.filterName !== 'price(upto)'"
            @filterChange="filterChanged($event)"
          />
          <!--           <filter-side-bar></filter-side-bar>-->
        </div>
      </div>
      <div class="apply-cont d-block d-md-none">
        <button
          class="ripplelink apply-btn btn btn-primary w-100"
          @click.prevent="applyMobileFilter"
          data-test="filterSidePanelApplyBtn"
          id="filterSidePanelApplyBtn"
        >Apply</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { productApi } from '@/services/ApiServices/productApi'
import FilterAccordion from './widgets/FilterAccordion'
import PriceSliderFilter from './widgets/PriceSliderFilter'

export default {
	name: 'filter-side-panel',
	props: {
		showLoader: {
			type: Boolean,
			default: true
		}
	},
	components: {
		PriceSliderFilter,
		FilterAccordion
	},
	data () {
		return {
			priceRange: {
				value: [0, 5000],
				width: '100%',
				height: 8,
				dotSize: 16,
				min: 0,
				max: 5000,
				interval: 500,
				disabled: false,
				show: true,
				useKeyboard: true,
				tooltip: 'always',
				lazy: true,
				formatter: '?{value}',
				mergeFormatter: '?{value1} ~ ?{value2}',
				bgStyle: {
					backgroundColor: '#fff',
					boxShadow: 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)'
				},
				tooltipStyle: {
					backgroundColor: '#666',
					borderColor: '#666'
				},
				processStyle: {
					backgroundColor: '#999'
				}
			},
			filters: [],
			checkedFilters: []
		}
	},
	computed: {
		...mapGetters('category', [
			'getActiveCategories',
			'getActiveCategory',
			'isMultipleCategory'
		]),
		...mapGetters('filters', [
			'getFilters',
			'getFilter',
			'getFilterId',
			'getPriceRange',
			'getKeyWord',
			'emptyFilters',
			'getSelectedFilterValues',
			'isFilterApplied',
			'getFilterSelected',
			'isPriceFilterApplied'
		]),
		...mapGetters('productselected', ['getSelectedProduct'])
	},
	beforeMount () {
		this.updateFilterApplied(false)
		// if (this.priceRange.max < this.getPriceRange[1]) {
		//   this.priceRange.max = this.getPriceRange[1];
		// }
		// this.priceRange.value = this.getPriceRange;
		this.getAllFilters()
		this.$nextTick(() => {
			this.updateFiltersToLocal()
			// this.getFilterProducts();
		})
		// setTimeout(() => {
		//   this.updateFiltersToLocal();
		// }, 200);

		// THIS IS FOR 100VH ISSUE ON MOBILE BROWSERS
		window.addEventListener('load', () => {
			const vh = window.innerHeight * 0.01
			document.documentElement.style.setProperty('--vh', `${vh}px`)
		})
		window.addEventListener('resize', () => {
			// We execute the same script as before
			const vh = window.innerHeight * 0.01
			document.documentElement.style.setProperty('--vh', `${vh}px`)
		})
		this.setFilterSelected([])
		this.setPriceFilterApplied(false)
		this.updateFilterAppliedStatus(false)
	},
	updated () {},
	watch: {
		$route: {
			handler (val) {
				this.updateFilterApplied(false)
				this.setPriceFilterApplied(false)
				this.updateFilterAppliedStatus(false)
				this.setFilterSelected([])
				setTimeout(() => {
					this.updateFiltersToLocal()
				}, 100)
				this.$forceUpdate()
			},
			deep: true
		},
		// getActiveCategories: {
		//   handler(val) {
		//     this.$nextTick(() => {
		//       this.filters = [];
		//       this.emptyFilters();
		//       this.getAllFilters();
		//     });
		//   },
		//   deep: true,
		// },
		getPriceRange: {
			handler (val) {
				this.$forceUpdate()
				// this.getFilterProducts();
			},
			deep: true
		},
		getFilter: {
			handler (val) {
				this.$nextTick(() => {
					this.updateFiltersToLocal()
					// this.getFilterProducts();
				})
			},
			deep: true
		}
	},
	methods: {
		...mapActions('productselected', ['setSelectedProductData']),
		...mapActions('filters', [
			'setFilters',
			'updateFilterId',
			'updatePriceRange',
			'resetFilters',
			'updateFilterApplied',
			'updateFilters',
			'updateKeyWord',
			'setFilterClass',
			'setFilterSelected',
			'setPriceFilterApplied',
			'updateFilterAppliedStatus'
		]),
		...mapActions('category', ['setActiveCategories']),
		applyMobileFilter () {
			document.querySelector('.filter-sidebar').classList.remove('show')
		},
		clearAllFilters () {
			this.updateFiltersToLocal()
			this.$root.$emit('clearAllFilter')
			this.getFilteredProducts(this.checkedFilters)
		},
		getAllFilters () {
			if (this.isMultipleCategory) {
				return false
			}
		},
		updateFilterAppliedData () {
			this.updateFilterApplied(false)
			this.checkedFilters.forEach(fil => {
				if (fil.filterValues.length > 0) {
					this.updateFilterApplied(true)
				}
			})
		},
		// setActiveCategory(category) {
		//   const keyWord = {
		//     name: category.category_name,
		//     category_id: category.category_id,
		//     is_a_category: true,
		//   };
		//   productApi
		//     .getSearchedFilteredProducts({keyWord},'filteredSearchProducts')
		//     .then((res) => {})
		//     .catch((e) => {
		//       console.log(e);
		//     });
		// },
		// getPriceFilterProducts() {
		//   const products = [];
		//   this.getSelectedProduct.forEach((product) => {
		//     if (
		//       product.vendor_product_inventories &&
		//       product.vendor_product_inventories.length > 0
		//     ) {
		//       let price = product.vendor_product_inventories[0].price;
		//       const pro = this.product.vendor_product_inventories[0]
		//         .promotional_prices;
		//       const promo = pro[0].promotion_percentage;
		//       if (pro && promo > 0) {
		//         price -= price * (promo / 100);
		//       }
		//       if (
		//         price <= this.priceRange.value[1] &&
		//         price >= this.priceRange.value[0]
		//       ) {
		//         products.push(product);
		//       }
		//     }
		//   });
		//   this.setSelectedProductData(products);
		// },
		// getFilterProducts() {
		//   if (this.isMultipleCategory) {
		//     return false;
		//   }
		//   const filters = this.getFilters.filter(
		//     filter => filter.filterValues.length > 0,
		//   );
		//   const filterClass = {};
		//   filterClass.filters = filters;
		//   const a = {};
		//   a.filter_class = filterClass;
		//   a.query_parameter = this.getKeyWord;
		//   let urlReference = '';
		//   console.error('this.$route',this.$route)
		//   if (this.$route.path === '/all-products') {
		//     urlReference = 'filteredAllProducts';
		//   } else {
		//     urlReference = 'filteredSearchProducts';
		//   }
		//   productApi
		//     .getSearchedFilteredProducts(a, urlReference)
		//     .then((res) => {
		//       this.getPriceFilterProducts();
		//     })
		//     .catch((e) => {
		//       console.log(e);
		//     });
		// },
		applyFilter () {
			// this.updateFilters(this.checkedFilters);
			// this.updatePriceRange(this.priceRange.value);
			// this.$forceUpdate();
		},
		filterChanged (filterData) {
			const indexOfChangedFilter = this.checkedFilters
				.map(filter => filter.filterName)
				.indexOf(filterData.filterName)
			this.checkedFilters[indexOfChangedFilter].filterValues =
        filterData.activeFilters
			this.updateFilterAppliedData()
			this.getFilteredProducts(this.checkedFilters)
		},
		getFilteredProducts (filterData, filterType) {
			this.$emit('onLoading', true)
			this.updateFilterAppliedStatus(true)
			const postDataJson = {}
			postDataJson.filter_class = {}
			let priceFilters = {
				max_price: null,
				min_price: null
			}
			if (this.getPriceRange) {
				priceFilters = {
					max_price: this.getPriceRange[1],
					min_price: this.getPriceRange[0]
				}
			}
			postDataJson.filter_class.filters = []
			postDataJson.filter_class.ratings = []
			postDataJson.filter_class.filters = this.getFilterSelected
			if (this.getFilterClass) {
				Object.assign(postDataJson.filter_class, this.getFilterClass)
			}
			if (filterType === 'priceFilter') {
				// Object.assign(postDataJson.filter_class,filterData)
				postDataJson.filter_class.min_price = filterData.range_min
				postDataJson.filter_class.max_price = filterData.range_max
				this.setPriceFilterApplied(false)
				this.updateFilterApplied(true)
			} else {
				postDataJson.filter_class.filters = filterData.filter(
					value =>
						value.filterValues.length > 0 &&
            value.filterName !== 'ratings' &&
            value.filterName !== 'vendors' &&
            value.filterName !== 'discount above(%)' &&
            value.filterName !== 'discount above(amount)' &&
            value.filterName !== 'price(upto)'
				)
				const ratingsData = filterData.filter(
					value => value.filterName === 'ratings'
				)
				const vendorsData = filterData.filter(
					value => value.filterName === 'vendors'
				)
				const discountPercentageData = filterData.filter(
					value => value.filterName === 'discount above(%)'
				)
				const discountAmountData = filterData.filter(
					value => value.filterName === 'discount above(amount)'
				)
				postDataJson.filter_class.min_price = priceFilters.min_price
				postDataJson.filter_class.max_price = priceFilters.max_price
				postDataJson.filter_class.ratings = ratingsData[0].filterValues
				postDataJson.filter_class.vendors = vendorsData[0].filterValues
				postDataJson.filter_class.discount_amount =
          discountAmountData[0].filterValues
				postDataJson.filter_class.discount_percentage =
          discountPercentageData[0].filterValues
			}
			this.setFilterClass(postDataJson.filter_class)
			if (postDataJson.filter_class.filters) {
				this.setFilterSelected(postDataJson.filter_class.filters)
			} else if (!this.isFilterApplied) {
				this.setFilterSelected([])
			}
			this.updatePriceRange([
				parseInt(postDataJson.filter_class.min_price, 10),
				parseInt(postDataJson.filter_class.max_price, 10)
			])
			postDataJson.query_parameter = this.getKeyWord
			let urlReference = ''
			if (this.$route.path === '/all-products') {
				urlReference = 'filteredAllProducts'
			} else {
				urlReference = 'filteredSearchProducts'
			}
			productApi.getSearchedFilteredProducts(postDataJson, urlReference)
				.then((res) => {
					this.$emit('onLoading', false)
				})
		},
		updateFiltersToLocal () {
			this.checkedFilters = JSON.parse(JSON.stringify(this.getFilters))
			if (this.checkedFilters && this.checkedFilters.length > 0) {
				this.checkedFilters.forEach(element => {
					element.filterValues = []
				})
			}
			this.updateFilters(this.checkedFilters)
		}
	}
}
</script>
